import { Component, OnInit } from '@angular/core';
import { Config } from 'src/model/config.model';
import { ConfigService } from 'src/services/config.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  config!: Config;

  constructor(private _configService: ConfigService) {
  }

  ngOnInit(): void {
    this.config = this._configService.GetConfig();
  }

}
